var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.07,
    y: 387.65,
    width: 35.16,
    height: 11.19,
    transform: "translate(839.3 786.48) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.41,
    y: 88.4,
    width: 35.16,
    height: 11.19,
    transform: "translate(643.99 187.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.68,413c5.84-.1,20.81-.35,26.45-.42l8.71,0-.46.46,0-11.19.5.5-17.58-.07c-4.38,0-13.2-.14-17.58-.2l.24-.23L421.68,413Zm0,0-.23-11.19v-.24h.24c4.39-.06,13.2-.16,17.58-.19l17.58-.07h.5v.5l0,11.19v.45h-.45l-8.87,0c-5.6-.06-20.5-.31-26.29-.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,297.93c5.84-.1,20.81-.35,26.45-.41l8.71,0-.46.45,0-11.19.5.5c-5.84,0-20.73-.07-26.37-.15l-8.79-.11.24-.24-.24,11.19Zm0,0-.24-11.19v-.23h.24l17.58-.19,17.58-.07h.5v.5l-.05,11.19v.46h-.45l-8.87,0c-5.6-.07-20.5-.32-26.29-.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,312c5.84-.1,20.81-.35,26.45-.41l8.71,0-.45.45-.05-11.19.5.5c-5.84,0-20.73-.07-26.37-.15l-8.79-.11.24-.24L174.72,312Zm0,0-.23-11.19v-.23h.24l17.58-.19,17.58-.07h.5v.5l0,11.19v.46h-.45l-8.87-.05c-5.6-.06-20.5-.31-26.29-.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.26,
    y: 286.74,
    width: 35.16,
    height: 11.19,
    transform: "translate(423.67 584.67) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.16,
    y: 401.76,
    width: 35.16,
    height: 11.19,
    transform: "translate(121.48 814.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.77,
    y: 56.21,
    width: 35.16,
    height: 11.19,
    transform: "translate(160.7 123.6) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.16,81.51c5.84-.1,20.81-.35,26.45-.42l8.71,0-.46.46,0-11.19.5.5c-5.84,0-20.73-.08-26.37-.16l-8.79-.11.24-.23-.24,11.19Zm0,0-.24-11.19v-.24h.24c4.39-.06,13.19-.16,17.58-.2l17.58-.06h.5v.51l0,11.19V82h-.45l-8.87,0c-5.6-.06-20.51-.32-26.29-.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.07,67.4c5.84-.1,20.81-.35,26.45-.42l8.71,0-.46.46,0-11.19.5.5-17.58-.07c-4.38,0-13.2-.14-17.58-.2l.24-.23-.24,11.19Zm0,0-.24-11.19V56h.24c4.39-.06,13.2-.16,17.58-.2l17.58-.06h.5v.51l-.05,11.19v.45h-.45l-8.87,0c-5.6-.06-20.5-.32-26.29-.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.54,43.16c-46.43,0-46.51,66,0,66S199,43.16,152.54,43.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.77,82.36c-2.48,11.36-11.9,21.21-28.24,21.21-38.59,0-38.53-54.79,0-54.79h.76c-36.26.66-36.08,52.55.71,52.55C169,101.34,178,92.66,180.77,82.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,56A1.18,1.18,0,0,1,154,57.1v1.84A17.3,17.3,0,0,1,163,62.16c.45.32.7.6.7,1.06a1.23,1.23,0,0,1-1.3,1.14,1.27,1.27,0,0,1-.91-.32,15,15,0,0,0-7.53-3V73.92c7.63,1.47,10.85,4.09,10.85,8.6,0,4.87-4.47,8.32-10.75,8.5V94.6a1.21,1.21,0,0,1-2.41,0V91a19.78,19.78,0,0,1-11.3-4.45,1.2,1.2,0,0,1-.56-1A1.26,1.26,0,0,1,141,84.4a1.36,1.36,0,0,1,.9.32,17,17,0,0,0,9.8,4.19V75.81c-7.54-1.52-10.65-4-10.65-8.64s4.42-8.18,10.55-8.32V57.1A1.17,1.17,0,0,1,152.81,56Zm-1.1,17.46V60.92c-4.87.09-8.09,2.75-8.09,6.06C143.62,70.11,145.23,72,151.71,73.46Zm2.21,2.81V89c5-.09,8.29-2.76,8.29-6.25C162.21,79.53,160.45,77.6,153.92,76.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.81,248.6c-44.91,11.79-28.22,75.66,16.76,63.85S329.79,236.79,284.81,248.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.07,279.34C322.55,291,316,302.88,300.14,307c-37.32,9.79-51.18-43.22-13.91-53l.73-.18c-34.9,9.85-21.55,60,14,50.65C315.51,300.69,322,290,322.07,279.34Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.33,260.94a1.18,1.18,0,0,1,1.45.77l.47,1.77a17.25,17.25,0,0,1,9.46.85c.52.19.83.4,1,.84a1.24,1.24,0,0,1-1,1.44,1.27,1.27,0,0,1-1-.08,15.08,15.08,0,0,0-8-1L294,278c7.76-.52,11.54,1.2,12.68,5.56,1.24,4.71-2.21,9.18-8.24,10.95l.91,3.47a1.21,1.21,0,0,1-2.33.61l-.92-3.51A19.78,19.78,0,0,1,284,293.64a1.18,1.18,0,0,1-.78-.8,1.25,1.25,0,0,1,.92-1.43,1.4,1.4,0,0,1,1,.08,16.86,16.86,0,0,0,10.53,1.56l-3.32-12.67c-7.68.45-11.33-1.2-12.5-5.65s2.2-9,8.09-10.72l-.44-1.69A1.18,1.18,0,0,1,288.33,260.94Zm3.37,17.18L288.51,266c-4.68,1.33-7.12,4.72-6.28,7.92C283,276.93,285.07,278.38,291.7,278.12Zm2.85,2.15,3.22,12.27c4.83-1.37,7.32-4.78,6.43-8.15C303.39,281.32,301.2,279.9,294.55,280.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,120.43c-37.8,19.36-9.18,75.38,28.68,56S431.89,101,394,120.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.57,118.61c-36,18.46-7.4,74.47,28.68,56S433.66,100.13,397.57,118.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.51,140.64c3,10.61,0,22.71-12.7,29.2-29.95,15.34-53.7-31.15-23.8-46.46l.59-.29c-27.85,15-5.17,58.91,23.38,44.28C435.63,161.41,438.79,150.49,436.51,140.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.67,127.75a1.05,1.05,0,0,1,1.22.84l.31,1.73a14.26,14.26,0,0,1,8.22,1.63,1.22,1.22,0,0,1,.78.88,1.12,1.12,0,0,1-.93,1.28,1.07,1.07,0,0,1-.83-.16,12.41,12.41,0,0,0-7-1.63l2.18,12.06c6.8.2,10,2.15,10.77,6.38.82,4.56-2.43,8.49-7.78,9.63l.6,3.37a1.06,1.06,0,0,1-.84,1.22,1.08,1.08,0,0,1-1.23-.85l-.61-3.4a16.55,16.55,0,0,1-10.45-2.43,1.1,1.1,0,0,1,.24-2.09,1.08,1.08,0,0,1,.83.16,14.21,14.21,0,0,0,9.12,2.4l-2.22-12.28c-6.72-.25-9.82-2.14-10.6-6.45s2.4-8.36,7.64-9.43l-.3-1.64A1.07,1.07,0,0,1,408.67,127.75Zm2,16.54-2.13-11.76c-4.16.84-6.47,3.84-5.91,6.94C403.17,142.4,404.88,144,410.68,144.29Zm2.37,2.29,2.15,11.89c4.29-.86,6.64-3.87,6.05-7.14C420.71,148.35,418.88,146.82,413.05,146.58Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.45,149.66c33.79,6.07,24.87,56.13-9,50.06S55.6,143.59,89.45,149.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.27,149.09c32.21,5.78,23.29,55.85-9,50.06S54,143.31,86.27,149.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.36,175.3c.17,8.92,5.36,17.56,16.7,19.6,26.77,4.8,34.19-36.75,7.46-41.55l-.53-.08c25.06,5,17.88,44.34-7.65,39.76C66.93,191.16,61.91,183.46,61.36,175.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,157a.87.87,0,0,1,.68,1l-.26,1.39A11.62,11.62,0,0,1,89.84,163a1,1,0,0,1,.34.89.91.91,0,0,1-1.07.7.8.8,0,0,1-.58-.36,10.11,10.11,0,0,0-4.8-3.23l-1.82,9.74c5.09,2.1,6.94,4.5,6.31,7.91-.69,3.69-4.27,5.73-8.65,5l-.5,2.72a.87.87,0,0,1-1,.68.85.85,0,0,1-.68-1l.51-2.75a13.27,13.27,0,0,1-7.2-4.84.89.89,0,0,1-.25-.8.93.93,0,0,1,1-.71.91.91,0,0,1,.58.36,11.46,11.46,0,0,0,6.2,4.44l1.85-9.92c-5-2.12-6.81-4.44-6.16-7.92s4.21-5.63,8.48-4.94l.24-1.32A.87.87,0,0,1,83.68,157Zm-3.23,13.08,1.77-9.5c-3.39-.56-6,1-6.46,3.55S76.16,168.17,80.45,170.08Zm1.13,2.41-1.79,9.61c3.5.57,6.14-1,6.63-3.67C86.87,176,85.92,174.34,81.58,172.49Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.18,345.58a93.14,93.14,0,0,0-2.14-15c-1.06-4.45-2.57-9-5.37-12.68-2.57-3.36-6.25-6-10.54-6.56-4.12-.51-8,1.33-11.08,3.93-3.83,3.22-6.75,7.48-9.5,11.61a141.68,141.68,0,0,0-8.21,14.37c-.08.16.17.3.25.13a90,90,0,0,1,7.34-12,75.29,75.29,0,0,1,8.45-10.23c2.83-2.76,6.43-5.35,10.53-5.48s7.85,2.17,10.31,5.31c2.75,3.52,4.15,7.91,5.19,12.19a91.11,91.11,0,0,1,2.12,14.32c.81,9.91,1,19.88,1.25,29.81q.18,8.44.25,16.87,0,4.27.07,8.55a52.69,52.69,0,0,0,.33,8.24c.09.55,1,.5,1.09,0a49.48,49.48,0,0,0,.38-7.8Q261,397,261,393c0-5.25.07-10.5.05-15.75C261,366.68,260.9,356.1,260.18,345.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,319.58c-.9.36.32-10.2-3.84-11.55-5.88-1.91-19.37,1.54-26.84,11.55a22.08,22.08,0,0,0-3.25,6.73c3.71-1.8,16-7.48,19.05-5.74,2.8,1.59-14.78,7.1-20.19,10.65a41.67,41.67,0,0,0-.49,4.43c3.17-2.18,11.79-7.83,15.64-7.83,4.29,0-9.92,7.51-15.67,12.9A45.15,45.15,0,0,0,195.58,356c1.47-2.78,4.71-8.2,8.9-11.12,5.8-4.06,8.35,2.46,1,7.62-3.9,2.76-6.71,5-8.49,6.56a30.09,30.09,0,0,0,6.51,8.42,23.74,23.74,0,0,1,9.54-6.52c1.41-.5,3.73-1.14,6.52-2.08a61.22,61.22,0,0,0,2-10.82c.16-4.29,5.24-1.91,3.18,5.72-.39,1.43-.75,2.62-1.08,3.6a28.62,28.62,0,0,0,6.22-3.05c.28-2.49-.14-8.25-1.17-13.67-1.27-6.76,3.88-7.23,5,1.28.51,3.92-.24,8-.48,10.65,5.82-3.4,10.64-10.28,10.64-10.28a25.74,25.74,0,0,0-4-10.65c-2.86-4.32.23-6,3.1-2.12,1.6,2.17,2.54,5.82,3.07,8.62C252.17,317.6,244.57,312.85,227.85,319.58ZM200,342c-1.59-2.3,3.9-6.52,5.09-5.08C206.57,338.79,201.54,344.35,200,342Zm36.67-9.45c-2.22,1.61-4.36-3.72-2.91-4.64S238.52,331.21,236.62,332.59Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.52,329.59c-.76-1.5-1.54-3-2.41-4.41a25,25,0,0,0-2.76-4c.24-.29.47-.59.72-.88a.12.12,0,0,0-.18-.17c-.28.32-.54.65-.82,1a.24.24,0,0,0-.11.13c-1,1.24-2,2.52-2.94,3.82a45.51,45.51,0,0,0-4.85,1.4c-1.64.55-3.27,1.12-4.86,1.8-.17.07-.09.34.08.27,1.58-.7,3.18-1.38,4.82-1.93s3.12-.93,4.69-1.37c-.51.72-1,1.45-1.49,2.19a56.67,56.67,0,0,0-8.59,3.5c-2.9,1.38-5.69,3-8.47,4.58a.15.15,0,0,0,.15.25,94.5,94.5,0,0,1,8.42-4.37c2.69-1.26,5.48-2.29,8.19-3.49-6.83,10.66-10.93,22.95-16.4,34.33-.08.17.18.31.25.14,1.67-4,3.6-7.88,5.42-11.81,1.63-3.52,3.22-7.07,4.86-10.59q.72-1.54,1.47-3.09c-.3,5.69-.18,11.48-1.11,17.1a.14.14,0,1,0,.28,0c.39-6.08,1.47-12.06,1.42-18.18,0,0,0-.05,0-.08,1.16-2.32,2.39-4.62,3.73-6.85,2.26,5.33,4.64,10.73,5.69,16.45,0,.18.32.1.27-.08-1.54-5.73-3-11.47-5.72-16.77a63.85,63.85,0,0,1,4.81-6.93c.75,1.41,1.73,2.75,2.59,4.1s1.67,2.66,2.45,4a58.08,58.08,0,0,1,4.27,9c.06.18.34.09.27-.08C234.33,335.58,233,332.53,231.52,329.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.34,342.54c-4.38-4.39-9.48-10.16-16.25-10.15-6.53,0-11.34,5.28-14.11,10.7-2.89,5.68-3.92,12.11-4.74,18.36A221.51,221.51,0,0,0,248.51,384c-.12,4.19-.1,8.39,0,12.58a82.84,82.84,0,0,0,1,12.69c.12.67,1.21.7,1.25,0,.19-3.53.05-7.07,0-10.61s0-6.95.17-10.43q.38-10.55,1.59-21c.72-6.1,1.3-12.38,3.12-18.28,1.65-5.31,4.74-11.4,10.13-13.73,7.36-3.19,14.54,2.63,19.36,7.55C285.25,342.85,285.47,342.67,285.34,342.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.67,349.41c-5.87-.59-4.26-3.79,1.09-2.39a24.35,24.35,0,0,1,8,3.83,34.56,34.56,0,0,0-2.36-13.91c-4.9-1.23-9.36.93-13.94,3.07s-7.64-3.42-2.26-6.09a17.07,17.07,0,0,1,14.53-.26,22.73,22.73,0,0,0-1.31-2.06,24.28,24.28,0,0,0-4.48-5c-4,.32-6.23,2.79-7.41,3.57-1.69,1.11-4.35-.19-2.66-2.59,1.31-1.88,4.59-2.74,7.3-3-4.84-2.85-9.65-2.86-12.38-1.62-4.73,2.16-3.41,14.63-3.41,14.63s-12.41-6.64-16.48-1.41a15.52,15.52,0,0,0-2.58,6.1c4.4-1.61,9.8-2,10.3.63s-6.89,2-10.75,2.41c-.46,5.55.83,12.06,5.27,16.65,3.77-7.25,12.15-12.75,13.34-8.76s-7.81,5-11.49,10.43a24,24,0,0,0,5.16,2.88c2-3,5.37-7.17,7-5.91s-2.62,4.2-5.35,6.57a78.59,78.59,0,0,0,11.95,3.29c1-4.18,2.91-8.09,4.75-7.73s-1.73,4.73-3.27,8a120.4,120.4,0,0,0,16.43,2.08c.34-.09,2.6-6.69,3.61-14.91a23.82,23.82,0,0,0-8.53-1.71c-4.16-.19-4.55-4.92,1.66-4.26a15.93,15.93,0,0,1,7.18,3c.07-.86.12-1.75.15-2.65h0A23.52,23.52,0,0,0,298.67,349.41ZM297.12,343c.64-1.41,4.43-.91,4.06.82S296.6,344.15,297.12,343Zm-31.07,11.73c-.23-1.18,2.31-2.25,2.67-1.31S266.37,356.25,266.05,354.68Zm17.87,9.69c-2-1.06.87-5.66,2.72-4.92C288.15,360.06,285.93,365.42,283.92,364.37Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.89,372c-2.79-4.66-5.54-9.35-8.47-13.93-1.36-2.13-2.79-4.22-4.27-6.27.22,0,.44-.11.66-.16l1.11-.21q1.29-.23,2.58-.36c.82-.08,1.63-.13,2.45-.14a12.1,12.1,0,0,1,2.62.14c.1,0,.12-.14,0-.14-.87,0-1.76-.08-2.64-.09s-1.69,0-2.54.06-1.58.13-2.37.25c-.43.06-.87.14-1.3.23a6.74,6.74,0,0,0-.78.16q-2.26-3.12-4.7-6.1a56,56,0,0,1,15.26-4.88c.09,0,.06-.15,0-.13A51.82,51.82,0,0,0,285,345.1c-.89-1.09-1.78-2.18-2.69-3.26s-2.08-2.4-3-3.69c-.06-.08-.18,0-.11.08a53,53,0,0,1,3.54,4.33h0a53.87,53.87,0,0,0-5.67,4.56q-2.79,2.46-5.42,5.09c-.07.06,0,.16.09.1,1.74-1.73,3.54-3.38,5.43-4.94s3.87-3,5.76-4.56c0,0,0,0,0,0l1.29,1.7.66.86.05.06c.72.94,1.45,1.89,2.16,2.84a23,23,0,0,0-2.15,3.89c-.63,1.32-1.17,2.68-1.67,4a58.65,58.65,0,0,0-2.33,8.74c0,.09.12.13.14,0a51.39,51.39,0,0,1,2.54-8.57c.54-1.42,1.16-2.81,1.79-4.2s1.28-2.47,1.82-3.75l1.87,2.51c.17.25.34.5.52.74,0,.06,0,.13.06.13h0c1.91,2.67,3.74,5.41,5.51,8.18a2.5,2.5,0,0,0-.24.61c-.12.33-.22.67-.32,1-.2.69-.36,1.38-.49,2.08s-.21,1.32-.28,2a18.64,18.64,0,0,1-.16,2.26c0,.11.15.12.13,0a7.45,7.45,0,0,1,.16-2.1c.1-.72.23-1.44.4-2.15s.32-1.27.51-1.9c.1-.32.2-.63.31-.95.06-.16.14-.33.19-.51.83,1.3,1.66,2.61,2.46,3.92,1.61,2.61,3.2,5.23,4.8,7.83C302.76,372.23,303,372.11,302.89,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.89,407.78c-.07-2.64-.49-5.3-.78-7.93s-.58-5.28-.87-7.92c-.54-5.09-.84-10.29-2-15.28A22.22,22.22,0,0,0,250,365.23a10.13,10.13,0,0,0-6.1-2.91,10.51,10.51,0,0,0-6.47,2,22.55,22.55,0,0,0-5.45,5.74,55.85,55.85,0,0,0-4.24,6.89c0,.09.1.15.15.06a35.15,35.15,0,0,1,9.18-10.29,10.86,10.86,0,0,1,5.79-2.41,7.9,7.9,0,0,1,5.61,2.24c3.08,2.68,4.86,6.62,5.92,10.49,1.26,4.59,1.67,9.41,2.3,14.11.37,2.8.73,5.59,1.1,8.39s.6,5.63,1.19,8.38A.46.46,0,0,0,259.89,407.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.47,368.06c-6.07-.12-12.5,4.41-12.5,4.41s3.42-11.82-6.08-11.43c-5.64.22-12.68,6.14-14.1,15.37,2.18-1.16,6.76-3.38,10.39-3.44,4.92-.09,5.26,3.76-1.53,4.34a41.86,41.86,0,0,0-9.09,1.51,25.16,25.16,0,0,0,1.14,8.53c3.78-2.3,10.25-4.74,10.44-1.57.14,2.35-6.53,2.54-9.83,3.36A39.75,39.75,0,0,0,218,399.22a90.42,90.42,0,0,0,13.68-3.08,25.6,25.6,0,0,0-.43-4.95c-.8-4.21,2.3-4.29,2.7-.24a14.42,14.42,0,0,1-.29,4.52,40.57,40.57,0,0,0,8.78-4.14,26.78,26.78,0,0,0-1.94-9.34c-1.21-3.29,1.18-5.18,3.2-1.39,1.31,2.44.78,7,.35,9.6a14.73,14.73,0,0,0,2.87-2.94C253.38,378.23,249.53,368.19,243.47,368.06Zm-26.18,2.18c.22-1.7,4.46-1.38,4.25-.05S217,372.16,217.29,370.24Zm-4.72,13.88c.41-1.1,2.24-.95,2.15-.08S212.29,384.83,212.57,384.12Zm25.16,5.95c-2.46.1-1.65-5-.22-5.22C238.73,384.68,239.61,390,237.73,390.07Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.53,390.53c-.23-.63-.44-1.28-.64-1.93.18.66.35,1.32.47,2A.09.09,0,1,0,235.53,390.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,382.31c-.45-1.31-.95-2.61-1.46-3.89-.27-.69-.55-1.37-.85-2.05a8.26,8.26,0,0,0-.85-1.71,12.41,12.41,0,0,0,.77-1.66c0-.05,0-.09-.08-.05a19.23,19.23,0,0,0-1.85,2.87c-.27.45-.52.9-.78,1.35-.53,0-1.07.16-1.59.25s-1.14.22-1.71.35l-1.69.39c-.56.14-1.11.32-1.68.41a.09.09,0,1,0,.05.17,11.8,11.8,0,0,1,1.77-.46c.55-.12,1.1-.21,1.65-.29s1.1-.15,1.66-.2.83-.07,1.25-.11c-.23.4-.46.8-.68,1.2a1.74,1.74,0,0,0-.1.19,5.17,5.17,0,0,0-1.36.16c-.5.09-1,.18-1.47.29-1,.22-2,.45-2.95.72-2.06.58-4.09,1.23-6.11,1.9-.12,0,0,.2.07.17a59.25,59.25,0,0,1,6.13-1.71c1-.22,1.94-.44,2.92-.64l1.46-.31a11,11,0,0,0,1.14-.25q-1.58,2.89-2.94,5.89c-2,4.35-3.62,8.84-5.31,13.31,0,.11.13.18.17.07a123.77,123.77,0,0,1,5.65-13c.38-.77.77-1.54,1.16-2.31,0,.15.07.31.1.47.1.53.19,1.06.28,1.58.18,1.06.36,2.12.51,3.18a37.73,37.73,0,0,1,.77,6.6c0,.14.2.13.18,0A31.28,31.28,0,0,1,227,392c-.07-1.11-.15-2.22-.28-3.33s-.26-2.13-.44-3.19c-.09-.53-.18-1.06-.28-1.59a3.15,3.15,0,0,0-.3-1.14c.56-1.12,1.11-2.24,1.67-3.35s1.06-2.08,1.61-3.12c.23-.44.47-.88.72-1.33a13,13,0,0,0,.63,1.6l.73,1.8c.55,1.32,1,2.66,1.56,4,.71,1.9,1.51,3.84,2.1,5.82C234.17,386.2,233.68,384.23,233,382.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.89,388.6c0-.15-.09-.31-.14-.46C234.79,388.29,234.84,388.45,234.89,388.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.76 402.64 275.09 416.77 273.37 453.19 235.8 453.19 234.08 416.77 233.41 402.64 275.76 402.64",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.76 402.64 275.34 411.58 233.88 412.58 233.41 402.64 275.76 402.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.74,
    y: 396.93,
    width: 47.69,
    height: 11.43,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.84,
    y: 453.19,
    width: 6.6,
    height: 5.98,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.84,
    y: 453.19,
    width: 6.6,
    height: 2.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.74,
    y: 453.19,
    width: 6.59,
    height: 5.98,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.74,
    y: 453.19,
    width: 6.59,
    height: 2.99,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.66,459.18c130.27-.61,276.41-.62,406.68,0-130.27.62-276.41.61-406.68,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.31,386.09s3.3,45.77,3.3,45.81c.05,9-.07,16.82-.51,20.88a.17.17,0,0,1,0,.07,6.34,6.34,0,0,1-.65,2.77l-.05.06c-2.66,1.82-74.29,4.27-76.81,3.51s-.58-8,2.13-10.33,29.72-15.51,29.72-15.51l-2.86-45.76Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,422.27s0,9.59,0,9.63c.05,9-.07,16.82-.51,20.88a.17.17,0,0,1,0,.07,11.66,11.66,0,0,1-.65,2.77l-.05.06c-2.66,1.82-74.29,4.27-76.81,3.51s-.58-8,2.13-10.33,29.72-15.51,29.72-15.51l-.14-9.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.58,459.2c2.53.75,74.15-1.7,76.81-3.52,1-.68,1.28-11.14,1.22-23.78,0-.13,0-.27,0-.4l-46.22,1.07,0,.78s-27,13.2-29.71,15.52S275,458.45,277.58,459.2Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.29,456.39c12.06-.71,60.79-2.43,72.76-2.22.1,0,.1.07,0,.08-11.94,1-60.68,2.29-72.76,2.34C278,456.59,278,456.41,278.29,456.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.55,433.62c4.72-1.05,10.55-.52,14.3,2.74.14.13,0,.34-.19.29a67.73,67.73,0,0,0-14.07-2.43A.3.3,0,0,1,305.55,433.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.19,435.81c4.72-1.05,10.55-.52,14.3,2.74.15.12,0,.33-.19.29a66.43,66.43,0,0,0-14.07-2.43A.3.3,0,0,1,302.19,435.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,438c4.72-1.05,10.56-.52,14.3,2.74.15.13,0,.33-.19.29a66.43,66.43,0,0,0-14.07-2.43A.3.3,0,0,1,298.83,438Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.37,433.87l-50.14-1s-6.11-90.22-5-120.3c1.24-32.67,15.27-129.89,15.27-129.89h42.35S350.05,280.28,349.82,313C349.61,343.27,358.37,433.87,358.37,433.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53,182.68l32.27,108c3-41.65,10.08-108,10.08-108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.84,187.47l-2.69,29-2.49,29c-1.6,19.37-3.11,38.73-4.26,58.14-.28,4.85-.46,9.72-.39,14.6s.3,9.72.55,14.58q.75,14.55,1.87,29.09T347.78,391l2.71,29L348.32,391q-1.08-14.54-2-29.07c-.62-9.69-1.27-19.38-1.72-29.08-.23-4.85-.41-9.7-.49-14.55s.13-9.67.43-14.52c1.06-19.39,2.59-38.76,4-58.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.33,424.51c7.83-.07,5.58-.16,13.41-.14,3.83,0,29,.09,32.57.73a.08.08,0,0,1,0,.16c-3.58.55-28.75,0-32.58-.06-7.83-.17-5.58-.21-13.4-.46A.12.12,0,0,1,310.33,424.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.27,361.54l24.2,39.34c3.93,8.06,7.23,15.19,8.59,19a.14.14,0,0,1,0,.06,6.42,6.42,0,0,1,.62,2.78s0,.06,0,.08c-1.61,2.79-65.09,36.06-67.7,36.48s-4-7-2.55-10.24,20.05-26.87,20.05-26.87L385.7,382.73Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.69,422.77a.2.2,0,0,1,0,.07c-1.61,2.79-65.09,36.06-67.7,36.48s-4-7-2.56-10.24,20.06-26.87,20.06-26.87l-4.25-7c10.38-5.53,29.24-15.24,40.95-21.26l4.29,7c3.93,8.06,7.23,15.19,8.59,19a.14.14,0,0,1,0,.07A6,6,0,0,1,459.69,422.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,459.32c2.61-.42,66.09-33.68,67.7-36.49.63-1.05-3.68-10.58-9.22-21.95-.06-.12-.11-.24-.17-.35l-41.19,21,.38.69s-18.6,23.6-20.05,26.87S389.38,459.74,392,459.32Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41,456.48c10.57-5.87,53.72-28.55,64.61-33.55.09,0,.12,0,0,.06-10.34,6.05-53.68,28.38-64.55,33.66C391.28,456.77,391.19,456.6,391.41,456.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.1,424.14c3.8-3,9.29-5,14.08-3.73.18,0,.11.32-.05.35a66.4,66.4,0,0,0-13.73,3.91A.31.31,0,0,1,406.1,424.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,427.57c3.8-3,9.29-5.05,14.08-3.73.18.05.11.31-.05.34a67,67,0,0,0-13.73,3.91A.3.3,0,0,1,404,427.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.94,431c3.8-3,9.29-5,14.08-3.73.18.05.11.32,0,.34a66.42,66.42,0,0,0-13.73,3.92A.31.31,0,0,1,401.94,431Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53,182.64a.28.28,0,0,0,0,.05c.19.87,3.15,14.6,6.22,26.4,2.23,8.63,4.53,16.2,5.84,17,1.49.88,8.77,4.1,11.2,5.11,0,0,11.36,81.64,20,107,8,23.36,41.21,84.77,41.21,84.77l47.82-24.16S413.2,336.41,409.27,325c-6.09-17.62-24.57-102.62-24.57-102.62s.44-7.24.34-9.9c-.2-5-7-26.24-8.57-29.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.39,413.32c6.83-3.82,4.82-2.82,11.69-6.56,3.37-1.83,25.49-13.84,28.93-15,.07,0,.14.1.07.14-2.88,2.21-25.21,13.83-28.61,15.6-6.94,3.61-5,2.49-12,6A.11.11,0,0,1,402.39,413.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.77,211.51c-1.26-.56-11.29-2.72-13.71-6.66-1.28-2.09-3.55-13.61-3.67-14.42,0-.12-.2-.08-.17,0,.13.54.15,11.57,3.24,16.13,2.17,3.21,12.93,5.26,14.21,5.28A.19.19,0,0,0,368.77,211.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.13,224.9a94.47,94.47,0,0,1,15,7,.17.17,0,0,1-.14.31c-5.05-2.17-10.2-4.25-15.12-6.69A.33.33,0,0,1,329.13,224.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.61,190.31c0-.17.32-.21.32,0a167.38,167.38,0,0,0,.85,16.87c.23,2.6,2.32,17,6.83,15.92.76-.17,1.14-.92,1.26-2.05a18,18,0,0,0-.6-4.41c-.5-3-.9-6-1.16-9.07a82.56,82.56,0,0,1,.19-17,.15.15,0,0,1,.29,0A154.84,154.84,0,0,0,337,214c.56,3.74,2.45,9.36-1.46,9.94s-6.56-8.84-7.05-11.42A85.91,85.91,0,0,1,327.61,190.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.49,223.47a24.35,24.35,0,0,1,1,3,6.87,6.87,0,0,1,.42,2.45c0,.16-.23.17-.31.07a8.53,8.53,0,0,1-1.05-2.39c-.34-.92-.71-1.83-1-2.76A.5.5,0,0,1,335.49,223.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.07,389.35c-6.81-12.82-12.26-23-19.3-35.72-3.47-6.25-7.1-12.43-10.41-18.77a113.72,113.72,0,0,1-7.57-19.58c-4.21-13.69-17.38-85.86-18.2-89.35-.5-2.12.43-14.06-.09-17.41s-5-20.48-5.62-22.14a.15.15,0,1,0-.29.09c2.06,6.74,4.36,18.37,5,21.88s-.27,16.37,0,18c.34,1.78,12.55,70.87,16.73,84.64,2,6.7,3.92,13.5,6.8,19.89s6.54,12.45,10,18.57c7.11,12.64,12.7,22.75,20,35.27.92,1.58,1.86,3.16,2.8,4.74C436,389.55,436.13,389.45,436.07,389.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.67,209.32c.9,0,3.55-1.86,3.87-2.34,2.22-3.34,2.76-13.95,2.94-16.74,0-.13.08-.09.08,0,0,3.13-.11,6.31-.37,9.32a33.38,33.38,0,0,1-1.15,7.25c-.68,1.9-4.4,3.21-5.38,2.78C315.6,209.61,315.6,209.32,315.67,209.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.25,131.56c-3.67,10.82-22,49.82-33.85,51.94-8.4,1.51-40-4.87-47.2-8.53-4.08-2.09,6.58-26.07,12.07-25.22,6.79,1.05,26,6.44,30,5.82,2.17-.33,13.46-13.12,29.6-30.3C341.17,116.45,345.43,122.21,342.25,131.56Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.94,175.73c-3.1-.65-18.89-5.28-22.5-7.32s-13.56-8.67-12.28-11.59,4.35-1.22,4.35-1.22-3.76-3.46-2.2-6.29,6.25,0,6.25,0-3.6-3.84-1.85-6.54,6,.91,6,.91-3.46-3.36-1.07-5c2.87-1.95,8.55,5,12.7,6.92.94.44,19.76,7.64,19.76,7.64Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,143.37c4.19,5.07,6.9,6.56,13,8.59.12,0,.09.22,0,.19-6.2-1.43-9.87-2.81-13.26-8.59C239.92,143.27,240.14,143.12,240.34,143.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,148.89c4.81,4.89,7.74,6.54,14,9.13.09,0,0,.19-.06.16-6.38-2-10-3.49-14.17-9C235.84,148.93,236,148.67,236.23,148.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.84,155.72c5,4.4,8.12,6.35,14.55,8.08a.12.12,0,0,1,0,.24c-6.72-1.13-10.65-3.53-14.62-8.15C232.45,155.58,232.52,155.45,232.84,155.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.36,150.54s-6-6.52-9.13-8.44-17.62-4.75-18.4-1.67c-1,4,7,7.26,11.14,8.35,0,0-2.36,9.22,2.89,12.81S277.36,150.54,277.36,150.54Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,141.62c1.7,4.3,7.22,5.38,11.16,6.74a.38.38,0,0,1,.2.59c-.73,3.93-.62,9.69,2.34,12.69a.1.1,0,0,1-.13.15c-3.61-2.79-4.18-8.44-3.11-12.69-4.05-1.33-9.55-2.65-10.5-7.47C249.86,141.61,249.89,141.59,249.9,141.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.36,149.72l-9.71,31.86s30.47,5.27,43.1,2.29c9.41-2.23,26.65-35.93,32.11-50.92s-3.77-15.22-11.3-7.37-26.87,28.57-28.2,29C302.45,154.92,277.36,149.72,277.36,149.72Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,167.14c.67-2.38,1.32-4.75,2-7.14s1.37-4.75,1.85-7.15a.1.1,0,0,0-.18-.06c-.85,2.21-1.48,4.54-2.18,6.81s-1.47,4.83-2.19,7.24c-1.42,4.78-2.66,9.59-3.84,14.44,0,.12.13.14.17,0C277.73,176.61,279.23,171.91,280.57,167.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,133c-5.46,15-22.7,48.69-32.11,50.92a48.43,48.43,0,0,1-11.35.91l43.12-63.87C344.74,122.13,345.42,125.91,342.86,133Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.64,201.25c1.7,1.35,67.5.77,67.78.29s-8.68-62-28.33-78.73c-5.66-4.81-16.37-4.43-20.25,1C325.73,136.63,314.57,200.4,315.64,201.25Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.98 137.58 340.21 132.47 335.94 137.14 337.16 141 341.24 141.32 342.98 137.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.24 141.32 342.14 187.36 335.53 201.3 328.91 186.47 337.16 141 341.24 141.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.29,169.11s-3.17-3.42-7.46-2.44-5.19,7.27-9.68,8.79-10.07-1.34-13.67,1.13-2.78,8.6-4.37,9.62,14.49,1.54,14.49,1.54S329,173.87,331.14,169.6",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.29,169.11s-3.17-3.42-7.46-2.44-5.19,7.27-9.68,8.79-10.07-1.34-13.67,1.13-2.78,8.6-4.37,9.62,14.49,1.54,14.49,1.54S329,173.87,331.14,169.6",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,258.78C287,260,292.89,257,295,257.39s12.78,3.82,24,4.48,21.44-4.1,23.25-4.07c.81,0,5.72.93,7.78-.75s-.65-6.65-.65-6.65,6.3-10.64,2.2-21.86c-4.31-11.79-18.92-17-26-25.36-2.35-2.77-4.14-17,1.33-24.24.18-.23.35-.47.51-.69.36-.49.68-1,1-1.41h0l.06-.09c3.7-5.6,2.87-7.64,2.87-7.64a8.71,8.71,0,0,1-7.81,4.26c-5.66,0-13.2-3.2-16.87-1.48s-1.06,8.61-1.81,10.57-1.74,1.67-5.8,1.13-10.25,4-4.74,4.34,11.75,11,9.62,16.17c-1.26,3.06-13.91,10.14-18.26,18.68-6.27,12.33,1.63,27.27,1.15,27.61S283.68,257.54,285.33,258.78Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,258.78C287,260,292.89,257,295,257.39s12.78,3.82,24,4.48,21.44-4.1,23.25-4.07c.81,0,5.72.93,7.78-.75s-.65-6.65-.65-6.65,6.3-10.64,2.2-21.86c-4.31-11.79-18.92-17-26-25.36-2.35-2.77-4.14-17,1.33-24.24.18-.23.35-.47.51-.69.36-.49.68-1,1-1.41h0l.06-.09c3.7-5.6,2.87-7.64,2.87-7.64a8.71,8.71,0,0,1-7.81,4.26c-5.66,0-13.2-3.2-16.87-1.48s-1.06,8.61-1.81,10.57-1.74,1.67-5.8,1.13-10.25,4-4.74,4.34,11.75,11,9.62,16.17c-1.26,3.06-13.91,10.14-18.26,18.68-6.27,12.33,1.63,27.27,1.15,27.61S283.68,257.54,285.33,258.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,258.06a3.91,3.91,0,0,0,1.69-.28,7.05,7.05,0,0,0,1.49-.78,7.77,7.77,0,0,0,1.26-1.1,7.93,7.93,0,0,0,.53-.65,6,6,0,0,0,.44-.74,6.73,6.73,0,0,0-.76.38l-.7.42c-.46.29-.89.59-1.32.89l-1.3.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.86,257.41l-1.39-.88-1.34-.84c-.45-.27-.9-.55-1.37-.81-.24-.13-.47-.26-.72-.38a8,8,0,0,0-.78-.34,5.89,5.89,0,0,0,.48.71,6.66,6.66,0,0,0,.56.62,7.39,7.39,0,0,0,1.33,1,6.62,6.62,0,0,0,1.53.7A3.9,3.9,0,0,0,295.86,257.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.41,204A10.1,10.1,0,0,0,323,205.4a15.52,15.52,0,0,0,1.75,1.15,16.42,16.42,0,0,0,1.89.91,9.92,9.92,0,0,0,2,.61,18,18,0,0,0-1.71-1.23c-.58-.37-1.17-.73-1.77-1.06s-1.21-.67-1.83-1A18.72,18.72,0,0,0,321.41,204Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.56,204a5.3,5.3,0,0,0,.51,1.36,7.83,7.83,0,0,0,.79,1.18,6.09,6.09,0,0,0,1,1,3.52,3.52,0,0,0,1.31.66c-.28-.41-.54-.78-.81-1.15s-.55-.73-.84-1.08-.59-.69-.91-1A7.65,7.65,0,0,0,319.56,204Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.78,204.56c-.25.67-.51,1.3-.8,1.92a19,19,0,0,1-.92,1.8A16.76,16.76,0,0,1,308,210c-.38.57-.83,1.08-1.25,1.67a6.1,6.1,0,0,0,1.78-1.21,7.15,7.15,0,0,0,1.33-1.71,7.44,7.44,0,0,0,.81-2A5.57,5.57,0,0,0,310.78,204.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.48,210.23a5.69,5.69,0,0,0,1.47-.7,7.57,7.57,0,0,0,1.25-1,7.31,7.31,0,0,0,1-1.26,4.2,4.2,0,0,0,.59-1.53c-.41.38-.77.74-1.14,1.09l-1.09,1.07c-.37.36-.73.72-1.08,1.11A11.49,11.49,0,0,0,301.48,210.23Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.75,206c-.47.6-.91,1.18-1.35,1.76l-1.3,1.74-1.32,1.72c-.44.59-.9,1.15-1.33,1.78a9.13,9.13,0,0,0,1.84-1.3,12.58,12.58,0,0,0,1.52-1.66,13,13,0,0,0,1.19-1.91A8.3,8.3,0,0,0,307.75,206Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M310.83,201.48a13.55,13.55,0,0,0-1.1-2.15,14.8,14.8,0,0,0-1.33-1.83,9.85,9.85,0,0,0-1.55-1.43,4.26,4.26,0,0,0-1.73-.78c.53.45,1,.9,1.51,1.38s.95,1,1.41,1.54C309,199.27,309.86,200.39,310.83,201.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.64,200.51a22,22,0,0,1,.66-3.65c.16-.56.33-1.12.54-1.65s.45-1.07.67-1.65a4.29,4.29,0,0,0-1.05,1.23,7.21,7.21,0,0,0-.71,1.72,8.69,8.69,0,0,0-.3,2A6.45,6.45,0,0,0,317.64,200.51Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M315.77,201.35c.23-.89.35-1.72.49-2.54l.23-1.23c.08-.4.18-.8.28-1.26a2.41,2.41,0,0,0-.7,1,6,6,0,0,0-.38,1.29,8.18,8.18,0,0,0-.11,1.4A5.89,5.89,0,0,0,315.77,201.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,202a17.24,17.24,0,0,1-6.2,3.32c-6.14,2.11-12.81,2.1-19.19,1.42-2.32-.25-1.43-3.78.87-3.54,5.73.62,11.76.53,17.26-1.36a17.74,17.74,0,0,0,3.62-1.67c.34-.2.65-.43,1-.65s-.32.29,0,0c1.71-1.59,4.37.91,2.65,2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,199.71a14.72,14.72,0,0,1-5.17,2.85c-5,1.8-10.61,1.91-15.89,1.39-2.29-.23-2.42-3.87-.1-3.64,4.89.49,10,.47,14.66-1.14a14.81,14.81,0,0,0,3.05-1.41c.29-.18.56-.37.84-.57s-.32.29,0,0c1.7-1.6,4.36.9,2.64,2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.72,
    cy: 233.52,
    rx: 16.08,
    ry: 17.02,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M305.59,221a.75.75,0,0,1,.75.71l0,1.21a9.84,9.84,0,0,1,5.46,1.95.86.86,0,0,1,.44.69.77.77,0,0,1-.76.78.7.7,0,0,1-.55-.2,8.77,8.77,0,0,0-4.61-1.83l.26,8.48c4.63.83,6.62,2.5,6.71,5.47.1,3.21-2.53,5.56-6.31,5.8l.07,2.36a.73.73,0,1,1-1.45,0l-.07-2.39a11.33,11.33,0,0,1-6.91-2.73.79.79,0,0,1-.35-.63.8.8,0,0,1,.73-.78.82.82,0,0,1,.56.2,9.77,9.77,0,0,0,6,2.58l-.26-8.63c-4.57-.87-6.5-2.48-6.59-5.5s2.5-5.48,6.2-5.68l0-1.15A.74.74,0,0,1,305.59,221Zm-.32,11.53-.25-8.27c-2.94.15-4.82,2-4.76,4.15S301.33,231.69,305.27,232.51Zm1.39,1.81.25,8.36c3-.15,4.94-2,4.87-4.27C311.72,236.32,310.62,235.08,306.66,234.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M363.05,132.36c16.2,21.48,27.6,53.17,23.12,62.3-3.23,6.59-38.46,11.2-59,13.32-3.81.39-4.49-29.71-.41-29.87,7.31-.28,32.23-6.69,32.72-6.74,1.06-.12-4.59-21.2-7.18-35C349,118.71,355.79,122.74,363.05,132.36Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,182.52a4.46,4.46,0,0,0,1.81,4.74,6.63,6.63,0,0,0-2.11,4c-.26,2.7,3.87,4.3,3.87,4.3a8.12,8.12,0,0,0-1.57,4.53c0,2.61,3.95,4.81,3.95,4.81a7.13,7.13,0,0,0,1.13,4.85c2.69,3.71,9.66,3.24,14.1,3s16.79-5.14,19.24-5.83l-1.4-28.5s-20.23-4.52-25.4-3.48C301.8,175.76,293.5,179.19,292.54,182.52Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.39,187.15c4.41-2.05,9.19-2.68,13.92-3.58a.09.09,0,0,1,0,.17c-4.72.84-9.21,2.6-13.88,3.63A.12.12,0,0,1,294.39,187.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.07,195.41a12.8,12.8,0,0,1,3.25-.68c1.16-.16,2.33-.3,3.5-.42q3.51-.37,7-.57c.1,0,.14.16,0,.17-2.33.25-4.66.53-7,.88-1.16.17-2.32.36-3.47.55a14.73,14.73,0,0,1-3.3.39A.17.17,0,0,1,296.07,195.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59,204.85a8.84,8.84,0,0,1,3-.46l3.2-.28c2.14-.21,4.27-.41,6.4-.69.1,0,.13.15,0,.16-2.16.3-4.32.62-6.48.89q-1.59.21-3.18.39a8.21,8.21,0,0,1-2.92.1A.06.06,0,0,1,298.59,204.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.76,176.18l6.45,33.34s44.7-6.76,50.21-13.31-5.1-38.8-20.45-61c-8.41-12.16-17.9-20-13.92,3.27s6.7,31.73,6.61,32S329.76,176.18,329.76,176.18Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.12,190.31c-.48-2.42-1-4.84-1.46-7.26s-.91-4.86-1.57-7.22a.09.09,0,0,0-.18,0c.24,2.36.72,4.72,1.12,7.07s.85,5,1.3,7.45c.88,4.9,1.93,9.76,3.06,14.61,0,.12.18.07.16,0C342.84,200.05,342.07,195.17,341.12,190.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,170.17c-.72,0-1.44.06-2.16.11a103.26,103.26,0,0,0-2.38-12c-1-4.06-2-8.12-3.09-12.15,0,0-.08,0-.07,0,.45,2.6.94,5.18,1.45,7.76-.45-1.22-.85-2.46-1.25-3.7,0-.08-.17,0-.15,0a23,23,0,0,0,1,3.43c.18.47.39.93.59,1.39.23,1.16.45,2.32.69,3.48a102.14,102.14,0,0,0,2.9,11.71A100.44,100.44,0,0,0,347.8,172c-4.37.83-13.59,2.64-17.83,3.94-.66.17-.26.41-.16.33s13.76-2.64,18.12-3.43c2.16-.4,4.33-.77,6.49-1.12s4.44-.66,6.63-1.19C361.23,170.48,361.26,170.17,361,170.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.48,201.88a67.57,67.57,0,0,1,9.57-3.39,22.46,22.46,0,0,1-9.57,3.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.61,133.28c3.82.86,10.25-4.66,12.78-9.41.17-.33-.36-3.74-.82-7.91-.27-2.53-.5-5.36-.53-7.95l-16.23,4.14a41.6,41.6,0,0,1,1.69,9.95,6,6,0,0,1-.1,1.06s0,.11,0,.18C336.07,125.37,335.91,132.45,339.61,133.28Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,108.24c-.71,4.39-3.41,14.87-12.09,15.17a9.89,9.89,0,0,1-1.67-.07c0-.07,0-.13,0-.18a6,6,0,0,0,.1-1.06,41.06,41.06,0,0,0-1.69-9.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.11,88.41c1.8,5.75-1.11,22.44-5.19,26.19-5.9,5.44-15.64,6-20.27-1.09-4.49-6.89-.31-28.58,4.25-32C338.61,76.49,350.44,79.9,353.11,88.41Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.53,98.73s.08.07.07.11c-.19,1.13-.22,2.45.75,3,0,0,0,.07,0,.06C337.1,101.52,337.16,99.77,337.53,98.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.7,97.69c1.84.12,1.47,3.78-.23,3.68S337.16,97.6,338.7,97.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,98.08s-.09,0-.09.09c-.08,1.14-.36,2.43-1.42,2.71,0,0,0,.06,0,.06C330.76,100.89,331.11,99.17,331,98.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.11,96.79c-1.82-.32-2.32,3.33-.64,3.63S331.63,97.06,330.11,96.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.1,96.44a14.29,14.29,0,0,1-1.43-.51,2.42,2.42,0,0,1-1.35-.79.77.77,0,0,1,.12-.94,2,2,0,0,1,1.95-.2A2.86,2.86,0,0,1,341,95.24.83.83,0,0,1,340.1,96.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.79,94.9a14.88,14.88,0,0,0,1.49-.23,2.43,2.43,0,0,0,1.48-.53.77.77,0,0,0,.05-1,1.93,1.93,0,0,0-1.88-.55,2.8,2.8,0,0,0-1.83.91A.83.83,0,0,0,328.79,94.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.08,109.37c-.3.24-.61.58-1,.57a2.91,2.91,0,0,1-1.2-.41,0,0,0,0,0-.05.06,1.54,1.54,0,0,0,1.38.76,1.22,1.22,0,0,0,1-.92A.06.06,0,0,0,337.08,109.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.22,105.85a3.91,3.91,0,0,1-2.75,1.47,5.07,5.07,0,0,1-1.4-.08l-.26,0-.25-.07a.28.28,0,0,1-.2-.27h0s0-.08,0-.12h0l0-.1c.06-.87.28-2.19.28-2.19-.34.12-2,.7-2,.24a58.43,58.43,0,0,1,2.66-11.55.1.1,0,0,1,.2,0c-.43,3.63-1.5,7.17-2,10.81a7.25,7.25,0,0,1,1.88-.37c.13.05-.46,2.55-.46,2.94a.1.1,0,0,0,0,0,5.36,5.36,0,0,0,4.12-.84C336.21,105.68,336.3,105.77,336.22,105.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.62,107a4.53,4.53,0,0,0,1.69,1.58,2.12,2.12,0,0,0,1.23.19c.92-.15,1-1,.92-1.69a5.1,5.1,0,0,0-.3-1.12A5.89,5.89,0,0,1,332.62,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.31,108.59a2.12,2.12,0,0,0,1.23.19c.92-.15,1-1,.92-1.69A2.11,2.11,0,0,0,334.31,108.59Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.84,101.74c-3-.4-2.16-7.66-2.16-7.66s-4.49-1.14-6.26-7.53c0,0-6.11,3.25-10.95,2-7.59-2-6.66-11.92-3.64-13.75,4.28-2.59,11.24,2.13,11.24,2.13s11.21-2.28,13.95,5.39a5.66,5.66,0,0,1,4.84,6C357.8,93.77,353.05,102,350.84,101.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.69,95a10.17,10.17,0,0,1-5.52-3.55,7.61,7.61,0,0,1-1.27-6.85.1.1,0,1,0-.19-.06,8.69,8.69,0,0,0,.7,7.38,7.06,7.06,0,0,0,6.24,3.3C349.77,95.23,349.82,95.05,349.69,95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,85.19c-1.37-2-3.66-2.49-6-2.57-.13,0-.13.2,0,.2A6.38,6.38,0,0,1,358,86.31c1,1.89.59,4.14,0,6.1a16,16,0,0,1-7.06,9c-.05,0,0,.12,0,.09a16,16,0,0,0,7.9-9.9C359.4,89.58,359.74,87.06,358.47,85.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.35,77.32a7.54,7.54,0,0,0-4-3.54,9,9,0,0,0-6.43.2,5.06,5.06,0,0,0-3,4.12,9,9,0,0,0,1.61,5.82s.1,0,.08,0a8.9,8.9,0,0,1-1.2-5.26,4.67,4.67,0,0,1,3-3.93c3.25-1.18,7.85-.62,9.68,2.74A.1.1,0,0,0,339.35,77.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.79,101.61s3.84-5.34,6.27-4-.5,9.16-3.39,10.19a2.92,2.92,0,0,1-3.89-1.62Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.16,99.85a0,0,0,0,1,0,.08c-2,.79-3.11,2.64-3.88,4.57a1.61,1.61,0,0,1,2.42-.41s0,.12-.05.11a1.8,1.8,0,0,0-2,.6,8.55,8.55,0,0,0-1,1.59c-.09.17-.42.07-.34-.13v-.05C349.36,103.64,351.4,100.08,354.16,99.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,121.37l4.16,9.49,11.56-12.54,3.51,3.8s-11.07,19.69-11.17,18.82l-4.23-8.16-5.53,5.95V124.24Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.3,131.57c.08-2.4.09-4.81.28-7.19,0-.09.14-.13.16,0,.56,2.29.2,11.44.28,13.62l0,0c.23-.26,5.14-5.24,5.19-5.17.91,1.29,4,7.23,4.22,7.77,1.75-3.12,9.21-15.47,11.3-18.45.06-.08.2,0,.15.08-1.53,3.3-11.15,19.59-11.3,19.55a93.25,93.25,0,0,1-4.42-8.63c-.82,1.08-5.76,6.68-5.79,6.33A76.34,76.34,0,0,1,334.3,131.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.12,459c-2.41.75-72.62-.77-75.18-2.48-1-.63,5-67.14,5-67.14l44.53.85-5.07,44.49S202.34,447,205,449.15,209.52,458.23,207.12,459Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,459c-2.4.75-72.62-.77-75.18-2.48-.31-.2-.4-6.95.71-15.74,12.73,2.13,58.18,9.11,61.72,7,2.47-1.45.28-3.72-1.74-5.25,5.8,2.9,11.22,5.68,12.34,6.61C207.57,451.32,209.52,458.24,207.12,459Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.69,424,134,423.42s8.66-104.71,8.3-106.72c-.46-2.58-31.47-124.19-31.47-124.19h41.72s32.9,113.35,34.08,124.27C188.51,334.42,177.69,424,177.69,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,413.55c2.58-.19,5.2-.16,7.79-.19s5.18,0,7.77,0c5.19.05,10.37.13,15.55.28,1.42,0,2.84.08,4.26.15s3,.33,4.54.38a.1.1,0,0,1,0,.19c-1.27,0-2.55.2-3.82.23s-2.64.05-4,.05q-3.9,0-7.78,0c-5.18,0-10.37-.11-15.55-.33-2.93-.12-5.88-.15-8.79-.45A.13.13,0,1,1,137.9,413.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,202.33c3.74,13.22,7.15,26.55,10.49,39.88s6.68,26.66,10,40l5,20c1.61,6.49,3.49,13,3.89,19.73s-.46,13.7-1,20.49-1.15,13.65-1.75,20.47c-1.19,13.66-2.34,27.32-3.82,40.95-.19,1.7-.37,3.41-.54,5.12,0,.14-.24.14-.23,0,.9-13.66,1.84-27.32,2.93-41q.83-10.25,1.67-20.48c.56-6.81,1.36-13.65,1.57-20.48s-1-13.5-2.71-20.16-3.27-13.06-4.9-19.58q-5-20-10-40c-3.7-14.93-7.4-29.89-10.67-44.93A.06.06,0,1,1,120,202.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.79,192.51s13.31,52.17,22.62,88.9l17.75-88.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,459.14c-2.41.75-72.62-.77-75.19-2.48-1-.63,2.68-67.18,2.68-67.18l43.95.86L124,434.86s25.91,12.27,28.53,14.45S157.09,458.4,154.69,459.14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,459.14c-2.41.75-72.62-.77-75.19-2.48-.31-.19-.23-6.77,0-15.75,12.73,2.13,58.89,9.12,62.43,7,2.46-1.45.28-3.72-1.74-5.24,5.8,2.89,11.21,5.67,12.33,6.61C155.13,451.48,157.09,458.4,154.69,459.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.17,192.49S148.81,222,144,229.4a73.49,73.49,0,0,0-12.1,6s-3,78.91-3,83.65c.2,17.73-4.33,104.08-4.33,104.08l-44.08-.42s4.57-97.65,4.59-104.14c0-6.28,3-45.91,5.66-80.26,0,0-3.92-11-3.49-16.52,1.05-13.43,7.08-29.31,7.08-29.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,220.54c.16-1.1.33-2.21.5-3.31.31-2,.72-4,1.07-6,.81-4.57,1.64-9.15,2.66-13.68a.1.1,0,0,1,.2,0c-.18,1.83-.39,3.65-.65,5.47s-.44,3.66-.7,5.48c-.51,3.61-1,7.23-1.62,10.82-.24,1.39-1.1,3.87.89,4.3,1.58.34,2.74-1.21,3.2-2.51a30.13,30.13,0,0,0,1.06-5c.33-1.82.61-3.65.87-5.48q.86-6,1.83-12c0-.11.21-.08.2,0a122,122,0,0,1-.88,12.23q-.39,2.91-.88,5.81a20.88,20.88,0,0,1-1.33,5.42,4.41,4.41,0,0,1-3.3,2.65h-.1a.13.13,0,0,1,.06.11c0,.65,0,1.31-.08,2s-.19,1.28-.31,1.91a12.66,12.66,0,0,1-.5,1.9,5.1,5.1,0,0,1-.86,1.67.11.11,0,0,1-.21-.06h0c0-.11,0-.21,0-.32v-.05h0a3.6,3.6,0,0,1,0-.56c0-.31.11-.62.18-.93.14-.61.31-1.23.47-1.83s.3-1.23.45-1.84.37-1.24.52-1.87a.07.07,0,0,1,0-.06,2.88,2.88,0,0,1-2.78-1.75A4.93,4.93,0,0,1,135.66,220.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,236.39a34.94,34.94,0,0,1,4.15-2.73,40.6,40.6,0,0,1,4.72-2.45c3.19-1.39,6.48-2.33,9.77-3.42.1,0,.17.13.07.17-3.19,1.27-6.24,2.95-9.32,4.46-1.52.74-3,1.44-4.6,2.13S130,236,128.4,236.61A.13.13,0,0,1,128.28,236.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.39,211.76c2.25,0,10-.57,12.3-3.14a15.53,15.53,0,0,0,2.87-5.18,48.67,48.67,0,0,0,1.74-6.28.09.09,0,0,1,.18,0,24.53,24.53,0,0,1-.9,7.13c-.54,2-1.27,4.17-2.86,5.55a11.31,11.31,0,0,1-6.09,2.23,27.85,27.85,0,0,1-7.24-.1C103.24,212,103.24,211.76,103.39,211.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.44,212.36a7.57,7.57,0,0,1-3-1.79c-1.69-2.56-2.1-10.67-2.25-12.81,0-.1-.05-.07-.05,0,0,2.4.08,4.83.28,7.14a25.11,25.11,0,0,0,.88,5.55c.52,1.45,3.37,2.45,4.11,2.12C156.49,212.58,156.49,212.36,156.44,212.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.43,414.19C85,414,87.62,414,90.21,414S95.4,414,98,414c5.18.05,10.37.13,15.55.28,1.42,0,2.83.08,4.25.14s3,.33,4.54.39a.09.09,0,0,1,0,.18c-1.28,0-2.55.2-3.83.24s-2.64,0-4,0l-7.78,0c-5.18,0-10.37-.11-15.54-.33-2.93-.12-5.89-.16-8.8-.45A.14.14,0,0,1,82.43,414.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.81,408.45h0a.52.52,0,0,1-.51-.56L97.22,237c-.13-.75-2.93-10.29-3.18-15.17-.27-5.15,5.06-25.24,5.29-26.09a.55.55,0,0,1,.66-.38.54.54,0,0,1,.38.65c-.06.21-5.51,20.78-5.26,25.77s3.16,15,3.18,15.1-10,171-10,171A.53.53,0,0,1,87.81,408.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,91.32s-8.83-6.17-19.57,1.49c-12.76,9.12-13.06,45.18-14.15,48.29s-2.54,3.71-3.33,6.51,1.37,4.93,1.54,6-3.25,5.95-3.25,5.95,15.23,5.87,25.29,5,21.86-6.37,21.86-6.37-1.88-3.41-1.72-4.9,2.14-3.3,2.3-6-3.59-6.49-3.84-8,4.86-28.27,3.55-38S147,91.32,147,91.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,157.49a14.55,14.55,0,0,1-1.82-3.58,2.06,2.06,0,0,1-.07-1c.73-2.12,2.85-3.84,2.74-6.22-.28-1.84-1.86-3.51-2.88-5a5.85,5.85,0,0,1-1.32-2.9c0-.39.06-.7.1-1.05,1.61-11.17,3.7-22.43,3.09-33.76A20.15,20.15,0,0,0,154,96.17a19.4,19.4,0,0,1,2.18,7.69c1.05,11.36-1,22.73-2.74,33.91,0,.32-.1.67-.11.95a5.66,5.66,0,0,0,1.15,2.49c1.06,1.66,2.61,3.34,2.85,5.39.07,2.53-2.11,4.19-3,6.33a1.84,1.84,0,0,0,0,.93,15.44,15.44,0,0,0,1.6,3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.57,158.05c.79-1.31,1.9-3,2.58-4.28l0-.05a3.31,3.31,0,0,0-.34-.64,7.78,7.78,0,0,1-1.47-5.72c.42-2.39,2.3-4.24,3.33-6.28a11.13,11.13,0,0,0,.93-4.45c1.1-13.19,3.37-35.49,14.53-44a13.87,13.87,0,0,1,4.22-2.13,14.68,14.68,0,0,0-4.08,2.31c-10.6,8.85-12.61,30.73-13.92,43.86a11.16,11.16,0,0,1-1.08,4.7c-1.14,2.14-2.94,3.7-3.45,6.07a6.8,6.8,0,0,0,.69,4.44c.25.54.57,1,.83,1.58a.65.65,0,0,1,.06.29,48.92,48.92,0,0,1-2.85,4.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82,149.63c11.84,20.39,26.44,42.2,36.06,43.78,7.49,1.24,26-1.75,44.48-9.68,3.52-1.51-12.11-27.26-14.71-26.57C198.73,159,179,165.6,178,164.77c-1.36-1.09-17.29-15.37-28.28-24.41C134.87,128.19,133.7,139.08,139.82,149.63Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.71,185.69c3.23-.45,17.8-3.82,21.65-5.67s14.53-8,13.42-11.05-4.39-1.55-4.39-1.55,4.11-3.3,2.7-6.3-6.42-.45-6.42-.45,4-3.69,2.36-6.59-6.23.52-6.23.52,3.79-3.21,1.45-5c-2.81-2.2-9.12,4.5-13.52,6.22-1,.4-20.81,6.48-20.81,6.48Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.2,154.31c-4.65,4.92-7.53,6.27-14,7.92-.12,0-.11.22,0,.2,6.47-1,10.33-2.2,14.21-7.9C239.64,154.25,239.43,154.08,239.2,154.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,160.27c-5.28,4.69-8.4,6.18-15,8.4-.09,0,0,.19.05.17,6.69-1.64,10.51-2.89,15.17-8.26C243.44,160.33,243.28,160.06,243,160.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,167.52c-5.43,4.17-8.78,5.95-15.5,7.28a.13.13,0,0,0,0,.25c7-.69,11.18-2.88,15.58-7.35C246.46,167.4,246.39,167.26,246.05,167.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,161.2s5.26-6.66,8.21-9.07,17.28-7.35,18.52-4.32c1.61,3.92-6.1,8.4-10.16,10.1,0,0,3.72,9.05-1.12,13.46S201.4,161.2,201.4,161.2Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,149c-1.11,4.63-6.59,6.52-10.4,8.46a.39.39,0,0,0-.12.63c1.31,3.9,2,9.78-.58,13.27a.1.1,0,0,0,.15.13c3.29-3.36,3.06-9.2,1.36-13.37,4-1.94,9.35-4.07,9.64-9.11A0,0,0,0,0,228.22,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.84,157.93l14.38,30.76s-30.42,8.8-40.26,5.18S146,164.54,138.45,147.82c-7.77-17.11,3.32-15,11-8.15s28.21,24.18,28.88,24.33S199.84,157.93,199.84,157.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.56,174.52q-1.41-3.18-2.85-6.34c-1-2.1-1.86-4.26-3-6.29-.05-.09-.21,0-.18.06.7,2.12,1.64,4.18,2.49,6.24s1.82,4.37,2.74,6.55c1.82,4.31,3.81,8.54,5.87,12.75.05.1.19,0,.15-.08C203.16,183.07,201.45,178.77,199.56,174.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.45,147.82c7.6,16.72,25.68,42.42,35.51,46,2.29.84,5.7,1,9.58.77l-42.77-59.86C136.2,133.82,133.5,136.94,138.45,147.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.49,181.57l1.95,17.23s-2.35-.11-10.12-.54L144.49,192,140.88,198l-49.12-3.85,7.53-13.49c5.92-13.06,13.43-32.76,23.31-42.17,7.85-7.48,16.42-6.32,21.54-.4,1.29,1.5,13.92,22.68,15.12,31.16C160.3,176.76,154.49,181.57,154.49,181.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41,176.86a59,59,0,0,1,9.11,1.73c1.48.44,2.93.94,4.38,1.48.73.27,1.45.51,2.18.75a9.59,9.59,0,0,0,2.35.51c.07,0,.07.11,0,.12a17.22,17.22,0,0,1-2.27-.07,14.75,14.75,0,0,1-2.15-.47c-1.5-.42-3-.92-4.5-1.36-3-.88-6.06-1.77-9.14-2.41C134.23,177.11,134.27,176.85,134.41,176.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.8,179.77a64.66,64.66,0,0,1,7.62-.33c1.27,0,2.53.14,3.8.29.6.07,1.21.15,1.81.24s1.31.3,2,.39c.06,0,.06.12,0,.12-.63-.07-1.27,0-1.9,0l-1.9-.07c-1.26-.05-2.53-.08-3.8-.14-2.54-.12-5.07-.21-7.61-.23C126.65,180,126.67,179.79,126.8,179.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,143.13c2.73,6.06,5.32,12.18,7.47,18.47,2.52,7.36,4.22,13-3.52,17.76l.12-.2c0,2.14,0,4.27-.11,6.41s-.12,4.27-.19,6.41c-.05-2.14-.12-4.28-.13-6.41s0-4.36,0-6.54l.12-.07c7.45-4.66,5.69-10.14,3.33-17.22-2.11-6.29-4.54-12.47-7.06-18.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,153.07a.82.82,0,0,1-.81.8.8.8,0,0,1-.8-.81.79.79,0,0,1,.81-.8A.8.8,0,0,1,144.14,153.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,162.16a.8.8,0,0,1-.81.79.79.79,0,0,1-.8-.81.8.8,0,0,1,.81-.8A.82.82,0,0,1,146.24,162.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,170.47a.81.81,0,1,1-.8-.81A.8.8,0,0,1,148.1,170.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,177.92a.81.81,0,1,1-1.61,0,.79.79,0,0,1,.81-.8A.8.8,0,0,1,143,177.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.61,186.2a.81.81,0,0,1-.82.8.8.8,0,0,1-.79-.81.81.81,0,0,1,1.61,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,135.67c.12,1.12,4.42,8.76,9.39,9.13,1.62.12,2.66-8.68,2.66-8.68l.22-.63,3.15-8.86-9.85-8.16-1.44-1.1s-.7,2.48-1.54,5.57l-.12.44c0,.18-.11.34-.15.51-.13.46-.26.93-.38,1.4s-.19.71-.28,1.09l-.27,1.13A58.41,58.41,0,0,0,131.88,135.67Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47,122.94a18.86,18.86,0,0,0,9.68,12.55l3.15-8.86-9.85-8.16-1.44-1.1S135.31,119.85,134.47,122.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,109.48c3.71,16.07-5.5,20.1-9,20.9-3.14.72-13.95,2.77-19.29-12.83s1-22.4,8.07-24.43S156.24,93.41,159.94,109.48Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.13,108.66a8.71,8.71,0,0,1-1.14-.06,1.77,1.77,0,0,1-1.15-.28.58.58,0,0,1-.11-.7,1.46,1.46,0,0,1,1.36-.56,2.2,2.2,0,0,1,1.45.53A.63.63,0,0,1,157.13,108.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18,110a10.45,10.45,0,0,0,1.06-.4,1.83,1.83,0,0,0,1-.63.57.57,0,0,0-.12-.7,1.42,1.42,0,0,0-1.46-.11,2.13,2.13,0,0,0-1.21,1A.62.62,0,0,0,146.18,110Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.07,112.74s-.07.06-.07.11c.24,1.1.33,2.4-.61,2.94,0,0,0,.08,0,.06C149.6,115.46,149.47,113.74,149.07,112.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,111.76c-1.81.19-1.3,3.78.37,3.6S149.39,111.6,147.88,111.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.2,112.05c-.29.25-.54.65-.92.74s-.81-.22-1.15-.54c0,0-.06,0,0,0,.08.69.45,1.35,1.2,1.35s1.08-.68,1.16-1.39C147.45,112.13,147.31,112,147.2,112.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.17,111.33s.1,0,.1.09c.12,1.12.43,2.38,1.49,2.61,0,0,0,.07,0,.07C155.51,114.09,155.1,112.41,155.17,111.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,110c1.77-.38,2.39,3.19.75,3.54S154.53,110.35,156,110Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,110.14c.31.14.65.44,1,.4s.62-.48.8-.89c0,0,.06,0,.07,0,.13.68,0,1.43-.6,1.67s-1.12-.28-1.4-.93C156.61,110.29,156.67,110.09,156.8,110.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,122.13c.29.24.59.57,1,.57a3.07,3.07,0,0,0,1.17-.4s.08,0,.06,0a1.52,1.52,0,0,1-1.36.75,1.21,1.21,0,0,1-1-.91C150.24,122.13,150.32,122.1,150.37,122.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,117.41s.48,1.62.6,2.4c0,.07-.17.14-.43.19,0,0,0,0,0,0a3.76,3.76,0,0,1-3.83-.83.08.08,0,0,1,.1-.13,5.66,5.66,0,0,0,3.55.45c0-.22-.92-2.75-.8-2.78a7,7,0,0,1,1.84.13c-.91-3.41-2.36-6.64-3.22-10,0-.12.15-.19.2-.08a56.83,56.83,0,0,1,3.92,10.68C156.42,117.83,154.72,117.49,154.39,117.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,119.73a4.62,4.62,0,0,1-1.49,1.76,2.06,2.06,0,0,1-1.2.34c-.93,0-1.12-.84-1.11-1.57a5.12,5.12,0,0,1,.16-1.14A6,6,0,0,0,154.44,119.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,121.49a2.06,2.06,0,0,1-1.2.34c-.93,0-1.12-.84-1.11-1.57A2.11,2.11,0,0,1,153,121.49Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.81,118.44a6.81,6.81,0,0,0,3.37-5.83,17.83,17.83,0,0,0,6.77-6.38c-.08.35-.69,2.86-1,4.14,10.31-2.78,12.92-11,12.92-11a18.09,18.09,0,0,1,5.08,6.28s-.43-6.43-4.06-10.46A10.39,10.39,0,0,0,145,91.63a14.84,14.84,0,0,0-14.09,5.57C124.66,105.14,131.81,118.44,131.81,118.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.73,108a19.34,19.34,0,0,1-5.21,2.39s0,0,0,0a16.42,16.42,0,0,0,7.31-5.25,14.84,14.84,0,0,0,2-3.33,10.66,10.66,0,0,0,1.08-4.09.08.08,0,1,1,.16,0,12.56,12.56,0,0,1-.5,4.18,11.55,11.55,0,0,1-2.06,3.65,13.34,13.34,0,0,1-2.78,2.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52,118.2s-4.29-4.6-6.42-3,1.59,8.61,4.44,9.24a2.8,2.8,0,0,0,3.5-2Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.22,117.18a0,0,0,0,0,0,.08c2,.5,3.27,2.13,4.23,3.86a1.54,1.54,0,0,0-2.34-.1s0,.12.06.1a1.72,1.72,0,0,1,2,.33,8.66,8.66,0,0,1,1.1,1.38c.12.16.41,0,.32-.16l0,0C134.22,120.19,131.86,117.06,129.22,117.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,135.52l-3.26,7.37-9-9.79L129.22,136s8.56,15.35,8.64,14.67l3.31-6.33,4.28,4.64,0-11.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,143.45c-.06-1.86-.06-3.74-.2-5.59,0-.07-.11-.1-.13,0-.43,1.78-.18,8.89-.25,10.59l0,0c-.18-.2-4-4.09-4-4-.71,1-3.14,5.61-3.3,6-1.36-2.44-7.12-12.06-8.74-14.38,0-.07-.15,0-.11.06,1.17,2.56,8.61,15.26,8.73,15.23s3.08-5.62,3.46-6.7c.64.85,4.46,5.22,4.48,4.94A59.32,59.32,0,0,0,145.79,143.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,71.67a45.41,45.41,0,0,1,1.94-13.5,45.09,45.09,0,0,1-1.94,13.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.23,75.27a45.28,45.28,0,0,1-5.08-12.66,45.58,45.58,0,0,1,5.08,12.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,94.45A45.62,45.62,0,0,1,190.47,86a45.16,45.16,0,0,1,10.73,8.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25,124.07a45.73,45.73,0,0,1-13.5-1.93,45.4,45.4,0,0,1,13.5,1.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.85,156.2a45.68,45.68,0,0,1-12.66,5.07,45.13,45.13,0,0,1,12.66-5.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,172.4a45.62,45.62,0,0,1,10.73,8.43,45.68,45.68,0,0,1-10.73-8.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.75,142.78a45.08,45.08,0,0,1,13.5,1.93,45.4,45.4,0,0,1-13.5-1.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.15,110.65a45.4,45.4,0,0,1,12.66-5.08,45.34,45.34,0,0,1-12.66,5.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,84.62A45.07,45.07,0,0,1,297.4,73.9,45.53,45.53,0,0,1,289,84.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.61,146.17c-8,32.58-37.1,38.08-37.1,38.08-2.84,4.69-8.49,19.16-8.49,19.16l-35.93-5.83s-.41-15.44-1.62-20.79c0,0-25.89-14.41-23.17-47.85,1.88-23.24,23.71-54.5,62.17-48.28l.4.07C297.32,87,308.16,123.52,302.61,146.17Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,146.17c-4.23,18.52-18.66,33.79-37,38.12-3.44,6.08-5.78,13-8.56,19.22l-36.07-5.79c-.17-5.26-.41-10.52-.91-15.75a46.41,46.41,0,0,0-.73-5.14l.09.12a48,48,0,0,1-11.08-9.5c-9.83-11-14-26.37-12-40.91,2.83-19.24,16.22-37.11,34.71-43.77,9.18-3.39,19.26-3.75,28.83-2,31.12,5,49.35,35.24,42.75,65.38Zm0,0c6.52-30-11.74-60.26-42.8-65.14-9.53-1.74-19.55-1.36-28.67,2-18.33,6.66-31.58,24.44-34.35,43.54-2.73,19.37,6,39.65,22.77,50l.08,0v.08a48,48,0,0,1,.73,5.19c.48,5.2.7,10.42.86,15.64l-.13-.15L257,203.3a148.81,148.81,0,0,1,8.4-19.09c18.53-4.44,32.9-19.55,37.17-38Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 227.24,
    y: 140.44,
    width: 3,
    height: 61.78,
    transform: "translate(-4.03 5.52) rotate(-1.37)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 174.65,
    width: 61.78,
    height: 3,
    transform: "translate(5.27 359.79) rotate(-70.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.15,163.79a5.84,5.84,0,0,1-.93-.08c-3.41-.55-6-4.2-7.58-8.59a4.59,4.59,0,0,1-3.51,1.23c-5.66-.92-6-12.93-6-13.44l1,0c0,.12.37,11.7,5.21,12.48a4,4,0,0,0,3-1.26,25.91,25.91,0,0,1-1.07-11.1c.53-3.27,2.06-4.95,4.22-4.6a3.46,3.46,0,0,1,2.83,2.28c1.23,3.23-1,9.14-3.86,12.64a11.59,11.59,0,0,1-1,1.08c1.42,4.25,3.83,7.82,6.94,8.33,2.33.37,5-1.09,7.45-4.12.2-.25.41-.51.61-.78a15.71,15.71,0,0,1-1.82-10.64c.68-4.2,2.68-6.54,5.22-6.13a2.7,2.7,0,0,1,2.15,1.85c1.21,3.17-.83,9.94-4.35,15a5.53,5.53,0,0,0,3.53,2.15c3.45.58,7.82-7.18,9.21-10.21l.91.42c-.22.47-5.38,11.57-10.28,10.78a6.45,6.45,0,0,1-4-2.34c-.14.2-.3.39-.45.58C251.86,161.38,249.22,163.79,246.15,163.79ZM256.29,142c-2.07,0-3.28,2.81-3.68,5.34A15.63,15.63,0,0,0,254,157c3.17-4.69,5.08-10.91,4-13.7a1.75,1.75,0,0,0-1.38-1.23Zm-16.37-2.65c-1.8,0-2.46,2.34-2.7,3.8a24.77,24.77,0,0,0,.89,10.15c.18-.2.36-.4.54-.62,2.62-3.22,4.78-8.79,3.7-11.65a2.45,2.45,0,0,0-2.06-1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.96,
    y: 200.36,
    width: 48.32,
    height: 26.59,
    transform: "translate(37.23 -35.18) rotate(9.2)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.44,229.77c-3.62,4.51-9.72,8.09-20,6.43s-14.92-7-16.92-12.41Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.44,229.77a18.09,18.09,0,0,1-3.75,3.53l-32.43-7.84a17,17,0,0,1-.71-1.67Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.68 209.63 212.44 206.11 212.81 203.82 264.05 207.34 263.68 209.63",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.56 216.56 211.31 213.04 211.68 210.75 262.93 214.26 262.56 216.56",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.43 223.48 210.19 219.97 210.56 217.68 261.81 221.19 261.43 223.48",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,119.43c1.7.57,5.42-8.08,16.82-17,5.07-3.94,22.36-7.09,22-12.64s-15.79-2.4-24.51,4.91C208.35,106.51,206.45,118.9,208,119.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.54,138.83c3.22.52,4-4.48.81-5S291.32,138.31,294.54,138.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.71,175c1.54,1.63,11.36-4.86,16.73-13.64,4.46-7.28,6.6-17.06,4.55-18s-5.64,12.39-9,17C280.68,166.1,271.07,173.27,272.71,175Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.66,155.45c6,26.13,21.81,58.58,31.05,59.22,10.29.72,2.41-35,1-35.79-1-.57-11.94-13.09-23.15-28.51S121.18,149,122.66,155.45Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.87,178.75c-1.77-2.07-16.71-22.1-23.37-30.59S119.68,141.32,122,155s10.81,39.68,22,52.87c10.77,12.71,16.18,7.06,15.8-6C159.51,191.15,154.87,178.75,154.87,178.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.51,182.33c-2.14-2.68-4.25-5.39-6.34-8.1s-4.16-5.46-6.24-8.19l-6.15-8.26-3-4.15c-1-1.39-2-2.78-3-4.18,1.08,1.34,2.13,2.69,3.2,4l3.15,4.07,6.24,8.18c2,2.76,4.11,5.5,6.14,8.26S155.53,179.53,157.51,182.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,155.73a19,19,0,0,1-1.28-2.39q-.28-.6-.54-1.23c-.17-.42-.32-.84-.47-1.27a13.11,13.11,0,0,1,1.35,2.35A16.48,16.48,0,0,1,137.65,155.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.69,214.62c7.68,0,15-7.94,36.87-29.08,3-2.92-11.74-30.87-15.13-27.91-4.28,3.72-20.06,19.1-21.07,20.37C145.82,188.72,148.49,214.62,153.69,214.62Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,165.67s6-9.79,10.29-16c2.37-3.47,7-9,9.88-10.8,4.35-2.62,24.2-10.79,26.29-6,1.89,4.32-16.07,9.18-16.07,9.18s17.69-6.5,19-.88-19.69,8.4-19.69,8.4,18.31-6.27,18.75-.26c.34,4.54-18.55,8.14-18.55,8.14s15.78-5.28,16.32-.62c.6,5.14-16.63,9.55-16.63,9.55-.61,12.07-5.83,17.57-10,21C187.69,188.23,169.13,165.67,169.13,165.67Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,143.88c2.05-.83,4.12-1.7,6.24-2.35s4.26-1.24,6.43-1.69a37.51,37.51,0,0,1,8.6-1c-5.14.36-12.75,2.58-14.87,3.24s-4.26,1.19-6.37,1.85C193.23,144,193.22,143.9,193.26,143.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.48,151.57c2.67-1,5.28-2,8-2.85s5.33-1.39,8.07-2c.21-.05.17.08,0,.14-2.72.76-5.17,1.67-7.88,2.46s-5.44,1.47-8.11,2.36C195.46,151.65,195.44,151.59,195.48,151.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.2,158.51a63.93,63.93,0,0,1,12.54-3.42c.21,0,.14.12-.08.18-4.19,1.06-7.48,1.86-12.4,3.38C196.19,158.67,196.12,158.55,196.2,158.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.41,159.58l8.91,38.12s-20,17.89-27.8,17.21c-5.12-.46-8.67-26.81,1.66-37.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.8,194.39a26.1,26.1,0,0,1,6.37-17.45c.05-.05.16,0,.11.08-3.91,5.28-6.16,14.5-6.36,17.39C148.92,194.48,148.8,194.47,148.8,194.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.23,200.77c-1.21-4.14-2.19-8.33-3.16-12.54s-1.95-8.4-2.82-12.63c-.49-2.39-1-4.78-1.4-7.19,0-.06.09-.09.11,0,1.21,4.13,2.21,8.33,3.2,12.52s2,8.41,2.88,12.63c.52,2.38,1,4.78,1.4,7.18C173.46,200.83,173.27,200.9,173.23,200.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.12,159.32a37.29,37.29,0,0,0-3.72,3.39c-1.2,1.17-2.38,2.37-3.54,3.58-2.32,2.4-7.52,7.22-11,12.23,0,0,.43,0,.47-.1,1.53-2.47,16.81-17.14,17.88-18.47.06.12.11.23.18.35s.19.07.19,0-.06-.49-.07-.74A.25.25,0,0,0,172.12,159.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.12,163.69c5,11.68,19.08,48.77,31.55,51.26-13.75-2.09-27.57-38.8-31.55-51.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.93,166a24.9,24.9,0,0,1,2.75,4.56,9.8,9.8,0,0,1-2.75-4.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.17,69.41a65.84,65.84,0,0,1,6.22-5.32c2.17-1.66,4.43-3.21,6.74-4.67a97.17,97.17,0,0,1,14.62-7.55A87.89,87.89,0,0,1,249,45.13a84.48,84.48,0,0,1,32.38,6,102.79,102.79,0,0,1,28,17l-.13.17a129,129,0,0,0-28.71-14.88c-1.24-.51-2.55-.82-3.82-1.24s-2.55-.85-3.86-1.13l-3.91-.94c-1.3-.31-2.63-.48-3.94-.72a81.34,81.34,0,0,0-16-1.27A95.16,95.16,0,0,0,217.59,54a112.41,112.41,0,0,0-14.73,6.65A102,102,0,0,0,189.17,69.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.09 70.63 299.88 68.84 308.7 67.84 307.06 59.12 308.83 58.79 310.83 69.41 300.09 70.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.83,229.09a65.84,65.84,0,0,1-6.22,5.32c-2.17,1.66-4.43,3.21-6.74,4.67a97.17,97.17,0,0,1-14.62,7.55A87.89,87.89,0,0,1,251,253.37a84.48,84.48,0,0,1-32.38-6,102.57,102.57,0,0,1-28-17l.13-.17a128.62,128.62,0,0,0,28.71,14.89c1.24.5,2.55.82,3.82,1.24s2.55.85,3.86,1.13l3.91.93c1.3.32,2.63.48,3.94.73a82.11,82.11,0,0,0,16,1.27,94.92,94.92,0,0,0,31.43-5.91,111,111,0,0,0,14.73-6.64A102,102,0,0,0,310.83,229.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.91 227.87 200.12 229.66 191.3 230.66 192.94 239.38 191.17 239.71 189.17 229.08 199.91 227.87",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsSvg);
export default __webpack_public_path__ + "static/media/about-us-svg.0cf630736fd4fbf47decdf406f0f1e18.svg";
export { ForwardRef as ReactComponent };